import { ApplicationConfig, enableProdMode, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withRouterConfig } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { routes } from './app-routing.module';
import * as wjCore from '@mescius/wijmo';

export interface AppEnvironmentConfig {
    mcpServerBaseUrl: string,
    chatServerBaseUrl: string,
    wijmoKey: string;
    production: boolean;
}

export const AppEnvironment: AppEnvironmentConfig = {} as any;

async function appInitializer(): Promise<void> {
    // The initialization must start with fetching the environment configuration data from the server
    const envRequest = await fetch('/env.json');
    if (envRequest.ok) {
        const envData = await envRequest.json();
        Object.assign(AppEnvironment, envData);
    } else {
        console.warn('Could not load environment configuration from /env.json');
    }

    // initialize Wijmo library with license key
    wjCore.setLicenseKey(AppEnvironment.wijmoKey);

    if (AppEnvironment.production) {
        enableProdMode();
    }
}

export function appConfig(): ApplicationConfig {
    return {
        providers: [
            provideAppInitializer(appInitializer),
            provideZonelessChangeDetection(),
            provideRouter(routes, withComponentInputBinding(), withRouterConfig({paramsInheritanceStrategy: 'always'})),
            provideHttpClient(withInterceptorsFromDi())
        ]
    }
}
